import { useEffect } from "react";
import useUiuxStore from "../../../store/useUiuxStore"

export const Message = () => {

  const { message, setMessage, activeTab } = useUiuxStore();

  // 탭이 변경되면 메시지 초기화
  useEffect(() => {
    if (message) {
      setMessage("");
    }
  }, [activeTab?.key, setMessage]);

  return <div className="flex w-full h-[40px] px-[12px] pb-[6px]">
    <div className="w-full h-full border border-gray-300 flex items-center px-[12px]">
      <p>
        {message}
      </p>
    </div>
  </div>
}